import type { MegaGridFilterOp, MegaGridFilterType } from './MegaGridTypes';

/** How many value inputs an operator needs. */
export type MegaGridOpArity = 'none' | 'single' | 'double' | 'multi';

interface OpMeta {
    label: string;
    arity: MegaGridOpArity;
}

const OP_META: Record<MegaGridFilterOp, OpMeta> = {
    contains: { label: 'contains', arity: 'single' },
    notContains: { label: 'does not contain', arity: 'single' },
    equals: { label: 'is', arity: 'single' },
    notEquals: { label: 'is not', arity: 'single' },
    startsWith: { label: 'starts with', arity: 'single' },
    endsWith: { label: 'ends with', arity: 'single' },
    blank: { label: 'is blank', arity: 'none' },
    notBlank: { label: 'is not blank', arity: 'none' },
    anyOf: { label: 'is any of', arity: 'multi' },
    noneOf: { label: 'is none of', arity: 'multi' },
    eq: { label: '=', arity: 'single' },
    gt: { label: '>', arity: 'single' },
    gte: { label: '≥', arity: 'single' },
    lt: { label: '<', arity: 'single' },
    lte: { label: '≤', arity: 'single' },
    between: { label: 'between', arity: 'double' },
    dateOn: { label: 'is', arity: 'single' },
    before: { label: 'is before', arity: 'single' },
    after: { label: 'is after', arity: 'single' },
    dateBetween: { label: 'is between', arity: 'double' },
    isTrue: { label: 'is true', arity: 'none' },
    isFalse: { label: 'is false', arity: 'none' },
};

const OPS_BY_TYPE: Record<MegaGridFilterType, MegaGridFilterOp[]> = {
    text: ['contains', 'notContains', 'equals', 'notEquals', 'startsWith', 'endsWith', 'blank', 'notBlank'],
    enum: ['anyOf', 'noneOf'],
    number: ['eq', 'gt', 'gte', 'lt', 'lte', 'between'],
    percent: ['eq', 'gt', 'gte', 'lt', 'lte', 'between'],
    date: ['dateOn', 'before', 'after', 'dateBetween'],
    boolean: ['isTrue', 'isFalse'],
};

export function opsForType(type: MegaGridFilterType): MegaGridFilterOp[] {
    return OPS_BY_TYPE[type] ?? [];
}

export function defaultOpForType(type: MegaGridFilterType): MegaGridFilterOp {
    return OPS_BY_TYPE[type]?.[0] ?? 'contains';
}

export function opLabel(op: MegaGridFilterOp): string {
    return OP_META[op]?.label ?? op;
}

export function opArity(op: MegaGridFilterOp): MegaGridOpArity {
    return OP_META[op]?.arity ?? 'single';
}

export function opSelectData(type: MegaGridFilterType): { value: string; label: string }[] {
    return opsForType(type).map((op) => ({ value: op, label: opLabel(op) }));
}
